export default __webpack_public_path__ + "9b615556bf6bbecf44a04ceba8a6805a.jpg";